const carousels = [
  {
    type: 'slider-component',
    carouselEl: 'slider-component',
    slideListEl: '.slider',
    slideItemEl: '.slider__slide',
    nextButtonEl: '.slider-button--next',
    prevButtonEl: '.slider-button--prev'
  },
  {
    type: 'videowise-carousel',
    carouselEl: '.vw-cmp__carousel--root',
    slideListEl: '.keen-slider',
    slideItemEl: '.keen-slider__slide',
    nextButtonEl: '.rw__swiper-btn--next',
    prevButtonEl: '.rw__swiper-btn--prev'
  },
  {
    type: 'slideshow-component',
    carouselEl: 'slideshow-component',
    slideListEl: '.slider',
    slideItemEl: '.slider__slide',
    nextButtonEl: '.slider-button--next',
    prevButtonEl: '.slider-button--prev'
  }
]

const trackCarousel = (config) => {
  const metadata = window.mixpanelCarouselsData
  // Find all carousel elements for this config
  const carouselElements = document.querySelectorAll(config.carouselEl)
  carouselElements.forEach((carousel) => {
    // Query sub-components off the carousel element
    const slideList = carousel.querySelector(config.slideListEl)
    const slides = slideList ? Array.from(slideList.querySelectorAll(config.slideItemEl)) : []
    const nextBtn = carousel.querySelector(config.nextButtonEl)
    const prevBtn = carousel.querySelector(config.prevButtonEl)
    
    // Using our own internal index for tracking purposes
    let currentIndex = 0
    // Keep track of which slides have already been observed
    const slidesSeen = new Set()
    
    // Function to fire the "Slide in view" event
    const trackActiveSlide = (trigger) => {
      if (!slidesSeen.has(currentIndex)) {
        slidesSeen.add(currentIndex)
        Shopify.analytics.publish('Slide in view', {
          type: config.type,
          product_id: metadata.productId,
          carousel_position: currentIndex,
          trigger,
          timestamp: new Date().toISOString()
        })
      }
    }
    
    // Listen for next button clicks (do not change any styles)
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        // Assume the carousel advances by one slide
        currentIndex = (currentIndex + 1) % slides.length
        trackActiveSlide('next')
      })
    }
    
    // Listen for previous button clicks
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentIndex = (currentIndex - 1 + slides.length) % slides.length
        trackActiveSlide('prev')
      })
    }
    
    // Observe when the entire carousel is in view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          Shopify.analytics.publish('Carousel in view', {
            type: config.type,
            timestamp: new Date().toISOString()
          })
        }
      })
    }, { threshold: 0.5 })
    observer.observe(carousel)
    
    // Track the initial active slide when the carousel loads
    // trackActiveSlide('initial')
  })
}

document.addEventListener('DOMContentLoaded', () => {
  carousels.forEach((config) => trackCarousel(config))
})